<svelte:options tag={null} />

<script lang="ts">
  import type { LinkIconPosition, LinkSize, LinkTheme } from './link.types';

  export let label: string;
  export let href: string;
  export let target: string;
  export let theme: LinkTheme = undefined;
  export let disabled = false;
  export let size: LinkSize = 'm';
  export let iconname: string | undefined = undefined;
  export let iconposition: LinkIconPosition | undefined = undefined;
  $: userClass = $$props.class;
  $: attributes = { ...$$restProps };
  $: delete attributes.class;

  function generateIconName(iconName: string): string {
    return `${iconName} size="1rem"`;
  }

  function generateIconClass(iconposition: string): string {
    const classes = ['mc-link__icon'];

    if (iconposition === 'left') {
      classes.push('mc-link__icon--left');
    }

    if (iconposition === 'right') {
      classes.push('mc-link__icon--right');
    }
    return classes.join(' ');
  }

  function setClasses(theme: LinkTheme, size: LinkSize): string {
    const classes = ['mc-link'];

    if (theme) {
      classes.push(`mc-link--${theme}`);
    }
    if (size) {
      classes.push(`mc-link--${size}`);
    }
    return classes.join(' ');
  }
</script>

<a
  {href}
  {target}
  class="{setClasses(theme, size)} {disabled ? 'is-disabled' : ''} {userClass}"
  {...attributes}
>
  {#if iconname && iconposition === 'left'}
    <span class={generateIconClass(iconposition)}>
      {@html `<${generateIconName(iconname)} />`}
    </span>
  {/if}

  {label}

  {#if iconname && iconposition === 'right'}
    <span class={generateIconClass(iconposition)}>
      {@html `<${generateIconName(iconname)} />`}
    </span>
  {/if}
</a>

<style lang="scss">
  @import '@mozaic-ds/styles/settings-tools/_all-settings';
  @import '@mozaic-ds/styles/components/c.links';
</style>
